import React, { Component } from "react"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"

class HowItWorks extends Component {
  toggleToolOptions = () => {
    let toolOptions = document.querySelector(".tool-type-options")
    toolOptions.classList.toggle("options-closed")
  }

  changeToolType = (type) => {
    return Promise.resolve(this.props.onToolTypeChange(type.toLowerCase()))
  }

  updateToolType = (type) => {
    this.trackClick(`Tools For ${type}`)
    this.changeToolType(type).then(() => {
      this.setDefaultImage()
    })
  }

  formatTextSelected = (text) => {
    if (text === "cios") {
      return "CIOs"
    }
    return text
  }

  setDefaultImage = () => {
    let { etrTools } = this.props
    for (let tool in etrTools) {
      if (etrTools[tool].type === this.props.selectedTool) {
        this.props.setToolImage(etrTools[tool].tools[0].image)
      }
    }
  }

  resetImage = () => {
    let { etrTools } = this.props
    for (let tool in etrTools) {
      if (etrTools[tool].type === this.props.selectedTool) {
        return etrTools[tool].tools[0].image
      }
    }
  }

  updateToolImage = ({ image, title }, event) => {
    this.trackClick(title)

    let parentEl = event.currentTarget.parentNode
    let currentEl = event.currentTarget
    if (parentEl.closest(".how-it-works-tools").querySelector(".filled")) {
      parentEl
        .closest(".how-it-works-tools")
        .querySelector(".filled")
        .classList.remove("filled")
    }

    currentEl.querySelector(".icon").classList.add("filled")

    this.props.setToolImage(image)
  }

  componentDidMount() {
    this.setDefaultImage()
  }

  trackClick = (name) => {
    this.props.trackEvent(`Clicked "${name}"`, { section: "#how-it-works" })
  }

  _renderTools = (position) => {
    let { etrTools, selectedTool } = this.props

    let { tools } = etrTools.find(({ type }) => type === selectedTool)

    return (
      <li className={`${position}-col`}>
        <ol className="tools">
          {tools
            .filter((tool) => tool.position === position)
            .map((tool, i) => (
              <li key={i} onClick={(e) => this.updateToolImage(tool, e)}>
                <div>
                  <div className="tool-header">
                    <span
                      className={`icon ${tool.icon} ${
                        i === 0 && position === "left" ? "filled" : ""
                      }`}
                    />
                    <h4 className="title">{tool.title}</h4>
                  </div>
                  <p className="content" dangerouslySetInnerHTML={tool.text} />
                </div>
              </li>
            ))}
        </ol>
      </li>
    )
  }

  render() {
    let { selectedTool } = this.props

    let toolTypes = ["Government", "Vendors", "CIOs", "Investors"]
    return (
      <section id="how-it-works" className="page-section">
        <div className="page-contain">
          <ul className="how-it-works-tools">
            {this._renderTools("left")}
            <li className="center-col">
              <div className="tool-type-selector">
                <div className="tool-type-dropdown">
                  <div
                    className="tool-type-selected"
                    onClick={this.toggleToolOptions}
                  >
                    <span>Tools for </span>
                    <div className="selected-option">
                      <span>{this.formatTextSelected(selectedTool)}</span>
                      <span className="glyphicon glyphicon-menu-down arrow-down"></span>
                    </div>
                  </div>
                  <ul
                    className="tool-type-options options-closed"
                    onClick={this.toggleToolOptions}
                  >
                    {toolTypes.map((option, index) => (
                      <li key={index}>
                        <span
                          className="tool-dropdown-option"
                          onClick={(_) => this.updateToolType(option)}
                        >
                          {option}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="image-gallery">
                <figure>
                  <img
                    src={
                      this.props.selectedToolImage
                        ? this.props.selectedToolImage
                        : this.resetImage()
                    }
                  />
                </figure>
              </div>
            </li>
            {this._renderTools("right")}
          </ul>
        </div>
      </section>
    )
  }
}

HowItWorks.propTypes = {
  etrTools: PropTypes.arrayOf(PropTypes.object),
  selectedTool: PropTypes.string,
  selectedToolImage: PropTypes.string,
  setToolImage: PropTypes.func,
  onToolTypeChange: PropTypes.func,
  trackEvent: PropTypes.func.isRequired,
}

export default HowItWorks
